import Notification from "app/models/notification"
import { Action, Types } from "./notifications.actions"

export type NotificationState = {
  notifications: Notification[]
}

const initialState: NotificationState = {
  notifications: [],
}

export default (state = initialState, action: Action) => {
  switch (action.type) {
    case Types.SHOW:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            id: action.payload.id,
            message: action.payload.message,
            values: action.payload.values,
            variant: action.payload.variant,
          },
        ],
      }

    case Types.HIDE:
      return {
        ...state,
        notifications: state.notifications.filter(n => n.id !== action.payload.id),
      }

    case Types.RESET:
      return {
        ...state,
        notifications: [],
      }

    default:
      return state
  }
}
